<template>
  <footer class="footer_wrapper">
    <div class="footer_content">
      <div class="footer_left footer_item">
        <div class="logo-wrapper flex-start">
          <img src="../../assets/home/whiteLogo.png" alt="logo" />
          <span>钒星北斗开放平台</span>
        </div>

        <div class="left-content">
          <div class="link bottom-item">
            <span>友情链接：</span>
            <!-- <a href="https://mp.weixin.qq.com/s/6F-R-wRlecV26raRUCAVVQ" target="_blank">操作指南</a>
          |
          <a
            href="https://mp.weixin.qq.com/mp/homepage?__biz=MzU0Mzg2OTE1Nw==&amp;hid=3&amp;sn=3087cfb695e0f57f23512a8bc3092266&amp;scene=18"
            target="_blank"
          >
            常见问题
          </a> -->
            <!-- | -->
            <a href="https://www.sysu.edu.cn" target="_blank">中山大学</a>
            |
            <a href="http://www.pgiot.com/" target="_blank">磐钴智能官网</a>
            |
            <a href="http://www.fanxingiot.com/" target="_blank">钒星物联网</a>
            |
            <a href="http://www.tiandiweitong.com/" target="_blank">天地卫通</a>
          </div>

          <div class="telephone bottom-item">
            <span>热线电话：4006281233</span>
          </div>

          <div class="telephone bottom-item flex-start-align">
            <div>销售工程师： </div>
            <div class="telephone ">
              <div class="flex-start bottom-item">
                <span>
                  <span>张</span>
                  <span style="margin-left: 1em;">工</span>
                  <span style="margin-left: 1em;">18988978129 (应急、水利、风电) </span>
                </span>
                <span style="margin-left: 2em;">
                  <span>龚经理</span>
                  <span style="margin-left: 1em;">18988974251 (应急、水利、消防)</span>
                </span>
              </div>
              <div class="flex-start mt10">
                <span>
                  <span>张经理</span>
                  <span style="margin-left: 1em;">18988972936 (应急、水利、海洋)</span>
                </span>
                <span style="margin-left: 2em;">
                  <span>肖经理</span>
                  <span style="margin-left: 1em;">18988974283 (应急、电力)</span>
                </span>
              </div>
            </div>
          </div>
          <div class="telephone bottom-item">
            <span>北斗卡办理：张工 18988978129 </span>
          </div>

          <div class="telephone bottom-item">
            <span>企事业合作：罗工 18988921981</span>
          </div>

          <div class="telephone bottom-item">
            <span>技术支持QQ群：133922463</span>
            <span class="gap">联系邮箱：open@pgiot.com</span>
          </div>
          <p class="bottom-item">公司地址：广州市黄埔区瑞和路39号纳金科技园G5座5楼</p>
        </div>
      </div>

      <div class="footer_right flex-start ">
        <div class="qrcode ">
          <img src="../../assets/home/applet.jpg" alt="code" />
          <p>扫码体验语音/图片压缩算法</p>
        </div>
        <div class="qrcode ml_30">
          <img src="../../assets/home/code.webp" alt="code" />
          <p>扫一扫关注磐钴智能公众号</p>
        </div>
      </div>
    </div>
    <div class="copyright-wrapper space-around">
      <div class="left-copy">
        <p class="copyright">Copyright©2017-2024 Pgiot.All Rights Reserved</p>
        <p class="support_container">
          <a href="https://beian.miit.gov.cn" target="_blank" class="record">粤ICP备17155728号</a>
        </p>
      </div>
      <div class="right-copy">
        <img style="height: 20px; width: 20px"
          src="https://16345310.s21i.faiusr.com/4/1/ABUIABAEGAAg8-OX7wUo8v_5wQEwFDgU.png" alt="备案logo" />
        <span>&nbsp;&nbsp;粤公网安备 44011202000904号</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer_wrapper {
  .footer_content {
    box-sizing: border-box;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 50px 0px;

    .footer_left {
      .logo-wrapper {
        margin-bottom: 20px;

        img {
          max-width: 50px;
          height: auto;
        }

        span {
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          margin-left: 10px;
        }
      }

      .left-content {
        color: #fff;

        .link {
          span {
            font-size: 16px;
          }

          a {
            color: #fff;
            text-decoration: none;
          }
        }

        .bottom-item {
          margin-bottom: 20px;
        }
      }
    }

    .footer_right {
      .qrcode {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          max-width: 128px;
          height: auto;
        }

        p {
          margin-top: 20px;
          font-size: 14px;
          color: #fff;
        }
      }
    }
  }

  .copyright-wrapper {
    width: 600px;
    margin: 0 auto;
    text-align: center;
    color: #666;
    font-size: 12px;
    margin-bottom: 20px;

    .left-copy {
      text-align: center;

      .copyright {
        margin-bottom: 10px;
      }

      .record {
        color: #666;
        text-decoration: none;
      }
    }

    .right-copy {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      span {
        display: inline-block;
        white-space: nowrap;
      }
    }
  }
}

.gap {
  margin-left: 10px;
  margin-right: 10px;
}

.ml_30 {
  margin-left: 30px;
}
</style>